import LoadingIndicator from '@orn/shared-web/components/LoadingIndicator';

/**
 * Loading placeholder for a settings tab. Centers a spinner inside a box that
 * mirrors the settings form footprint (same `max-w-[736px]`, a tall min-height)
 * so the spinner sits where the form will render rather than drifting to the
 * middle of the full-width tab panel.
 */
const SettingsTabLoading = () => (
  <div className="flex min-h-[60vh] w-full max-w-[736px] items-center justify-center">
    <LoadingIndicator size="md" />
  </div>
);

SettingsTabLoading.displayName = 'SettingsTabLoading';

export default SettingsTabLoading;
